import { jsx as _jsx } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { TextField } from "@mui/material";
export function SmilesInput({ smiles, setSmiles, }) {
    return (_jsx(TextField, { size: "small", fullWidth: true, id: "smiles", margin: "dense", variant: "outlined", label: "SMILES string", value: smiles, onChange: (e) => setSmiles(e.target.value) }));
}
